(function () {
  'use strict';

  var prompt = document.getElementById('WeeklyAppPrompt');
  if (!prompt || prompt.dataset.initialized) return;
  prompt.dataset.initialized = 'true';

  var COOLDOWN_DAYS = 7;
  var COOLDOWN = COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
  var SHOWN_KEY = 'dubia-app-prompt-shown-at';
  var INSTALLED_KEY = 'dubia-app-prompt-installed';
  var promotions = window.DubiaPromotionDrawers;
  var ua = navigator.userAgent || '';
  var isIOS = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isAndroid = /Android/.test(ua);
  var timer;
  var pageActive = true;
  var previousFocus;
  var testing = prompt.dataset.testing === 'true';
  var completedAction = false;

  // A first-party cookie backs up storage when localStorage is unavailable.
  function read(key) {
    var value;
    try { value = localStorage.getItem(key); } catch (_) {}
    if (value) return value;
    var cookie = document.cookie.split('; ').find(function (item) { return item.indexOf(key + '=') === 0; });
    return cookie ? cookie.slice(key.length + 1) : null;
  }

  function write(key, value, days) {
    try { localStorage.setItem(key, String(value)); } catch (_) {}
    document.cookie = key + '=' + value + '; Max-Age=' + days * 86400 + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    return read(key) === String(value);
  }

  function inApp() {
    return /DubiaRoachesApp/.test(ua) || Boolean(window.ReactNativeWebView) || document.documentElement.classList.contains('in-dubia-app');
  }

  if (inApp()) {
    write(INSTALLED_KEY, 'true', 365);
    return;
  }
  if ((!isIOS && !isAndroid) || typeof prompt.showModal !== 'function') return;

  window.addEventListener('dubia:product-drawer-viewed', scheduleAfterBrowsing);
  window.addEventListener('dubia:product-drawer-closed', scheduleAfterBrowsing);

  function scheduleAfterBrowsing() {
    if (!eligible()) return;
    clearTimeout(timer);
    timer = setTimeout(showWhenReady, 2500);
  }

  var storeLink = prompt.querySelector('[data-app-prompt-store]');
  function syncLink() {
    var installed = read(INSTALLED_KEY) === 'true';
    var openApp = installed;
    storeLink.href = openApp ? 'dubiaroaches://' : (isIOS ? prompt.dataset.iosUrl : prompt.dataset.androidUrl);
    storeLink.textContent = openApp ? 'Open app' : 'Get the App';
  }
  syncLink();
  if (!storeLink.getAttribute('href')) return;

  // Expose priority without changing this drawer's browsing or frequency rules.
  prompt.dubiaPromotionPending = function () { return eligible() && (testing || promotions.canShow('app', 1, true)); };

  function eligible() {
    if (!pageActive) return false;
    if (inApp()) return false;
    if (testing) return true;
    if (!promotions || promotions.hasShown('app')) return false;
    // Banner dismissal and drawer reminders have independent schedules.
    var shown = Number(read(SHOWN_KEY)) || 0;
    return !shown || Date.now() - shown >= COOLDOWN;
  }

  function close() {
    if (!prompt.open) return;
    if (!testing && promotions) promotions.closed('app');
    prompt.close();
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  }

  function dismiss() {
    if (!prompt.open || completedAction) return;
    completedAction = true;
    if (!testing && promotions) promotions.track('app', 'dismiss');
    close();
  }
  prompt.querySelector('[data-app-prompt-dismiss]').addEventListener('click', dismiss);
  prompt.addEventListener('cancel', function (event) { event.preventDefault(); dismiss(); });
  storeLink.addEventListener('click', function () {
    if (!testing && promotions) promotions.track('app', storeLink.getAttribute('href') === 'dubiaroaches://' ? 'open_app' : 'store_click');
    completedAction = true;
    close();
  });
  window.addEventListener('storage', function (event) {
    if (event.key === INSTALLED_KEY || event.key === SHOWN_KEY) {
      if (!eligible()) close();
    }
  });

  function showWhenReady() {
    if (!eligible()) return;
    if (!testing && !promotions.canShow('app', 1)) {
      timer = setTimeout(showWhenReady, 1000);
      return;
    }
    syncLink();
    var otherModal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(function (element) {
      if (element.closest('details:not([open]), [hidden], [aria-hidden="true"], [inert]')) return false;
      return element !== prompt && element.getClientRects().length && getComputedStyle(element).visibility === 'visible';
    });
    var input = document.activeElement;
    if (document.visibilityState !== 'visible' || (input && (input.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(input.tagName))) || document.body.matches('.product-card-drawer-open, .cart-notification-open, .overflow-hidden, .overflow-hidden-mobile, .overflow-hidden-tablet') || otherModal) {
      timer = setTimeout(showWhenReady, 1000);
      return;
    }
    // Skip instead of nagging on every page when all persistent storage is blocked.
    if (!testing && (!write(SHOWN_KEY, Date.now(), COOLDOWN_DAYS) || !promotions.shown('app'))) return;
    previousFocus = document.activeElement;
    var scrollX = window.scrollX;
    var scrollY = window.scrollY;
    prompt.showModal();
    if (!testing) {
      promotions.track('app', 'impression');
    }
    prompt.focus({ preventScroll: true });
    // Some mobile browsers scroll the document while focusing a bottom dialog.
    window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' });
    completedAction = false;
  }

  window.addEventListener('pagehide', function () { pageActive = false; clearTimeout(timer); close(); });
  window.addEventListener('pageshow', function (event) {
    syncLink();
    if (event.persisted) {
      pageActive = true;
      timer = setTimeout(showWhenReady, 2500);
    }
  });
  timer = setTimeout(showWhenReady, 2500);
})();
